<template>
  <div>
    <div class="member-classes-period">
      <div class="member-classes-period-main">
        <div
          class="member-classes-period-title"
          :class="{ 'member-classes-period-title_hover': !playDisable }"
          @click="onPeriodPlay"
        >
          <CoursePeriodsType
            :periods_type="period.periods_type"
          ></CoursePeriodsType>
          <template v-if="[2, 3, 4].includes(+period.periods_type)">
            <template v-if="period.play_type == 1">
              <img
                class="member-classes-period-icon"
                src="@/assets/images/classes/wait@2x.png"
              />
              <span class="member-classes-period-state color-9">未开始</span>
            </template>
            <template v-else-if="period.play_type == 2">
              <img
                class="member-classes-period-icon"
                src="@/assets/images/classes/living@2x.png"
              />
              <span class="member-classes-period-state color">上课中</span>
            </template>
          </template>
          <span>{{ period.periods_title }}</span>
        </div>
        <div class="member-classes-period-info color-9">
          <template v-if="period.start_play">
            <span>{{ period.start_play }}</span>
            <span class="mh10">|</span>
            <span>
              {{ period && period.teachers ? period.teachers.join("、") : "" }}
            </span>
          </template>
        </div>
      </div>
      <div class="member-classes-period-btns">
        <div class="color-9" v-if="period.leave_status == 1">
          已请假，待审批
        </div>
        <div class="color-9" v-else-if="period.leave_status == 2">已请假</div>
        <template v-else>
          <div
            class="color-9"
            v-if="period.leave_status == 3 && period.leave_allow == 1"
          >
            请假驳回，重新请假
          </div>
          <div
            class="color-9"
            v-if="period.leave_status == 3 && period.leave_allow != 1"
          >
            请假驳回
          </div>
          <template>
            <div
              v-if="period.leave_allow == 1"
              class="member-classes-period-btn"
              @click="onLeave"
            >
              请假
            </div>
          </template>
          <template v-if="[2, 3, 4].includes(+period.periods_type)">
            <div
              class="member-classes-period-btn"
              :class="{
                'member-classes-period-btn_disable': playDisable,
              }"
              @click="onPeriodPlay"
            >
              {{ period.play_type > 2 ? "查看回放" : "进入直播间" }}
            </div>
          </template>
        </template>
      </div>
      <!-- 图文 和 面授课 隐藏 -->
      <template v-if="![7, 10].includes(+period.periods_type)">
        <el-progress
          type="circle"
          :percentage="period.progress_rate"
          status="success"
          :show-text="false"
          :width="30"
          :stroke-width="3"
        ></el-progress>
        <div class="member-classes-period-progress">
          {{ period.progress_rate }}%
        </div>
      </template>
      <CourseSoldOutTip
        v-if="showSoldOut"
        :show.sync="showSoldOut"
      ></CourseSoldOutTip>
      <CourseContentTip
        v-if="showContentDialog"
        :show.sync="showContentDialog"
        :content="chapter_content"
      ></CourseContentTip>
    </div>
    <FileList
      :showDownload="true"
      :period="period"
      :fileList="getFile(period.datum)"
    />
  </div>
</template>
<script>
import CourseSoldOutTip from "@/modules/stu/components/CourseSoldOutTip.vue";
import CoursePeriodsType from "@/modules/stu/components/CoursePeriodsType";
import CourseContentTip from "@/modules/stu/components/CourseContentTip";
import FileList from "@/modules/stu/components/FileList";
export default {
  name: "MemberClassesPeriod",
  components: {
    CourseSoldOutTip,
    CoursePeriodsType,
    CourseContentTip,
    FileList,
  },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    period: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showSoldOut: false,
      showContentDialog: false,
      chapter_content: "",
    };
  },
  computed: {
    playDisable() {
      if (this.course.course_type == 7 || this.course.course_type == 10) {
        return false;
      }
      return this.period.play_type > 2 && this.period.play_type != 4;
    },
  },
  methods: {
    //处理课时课件文件
    getFile(data) {
      if (data && data.length > 0) {
        return data.map(item => ({
          ...item,
          ware_filename: item.file_name,
        }));
      }
      return [];
    },
    async onPeriodPlay() {
      console.log(this.period);
      if (
        this.period.periods_type == 7 ||
        this.period.periods_type == 10 ||
        this.playDisable
      ) {
        if (this.period.periods_type == 7) {
          this.showContentDialog = true;
          this.chapter_content = this.period.content;
        }
      }
      if (this.course.status == 2 && this.course.is_go_to_study == 0) {
        this.showSoldOut = true;
        return;
      }
      if (
        !this.$services.CourseService.checkLiveState(
          this.course_type,
          this.period,
        )
      ) {
        return;
      }
      await this.$services.CourseService.checkLimit(
        this.course.course_basis_id,
      );
      await this.$services.CourseService.watchVideo(
        this.period,
        this.period.periods_type,
        this.course.course_basis_id,
      );
    },
    onLeave() {
      this.$emit("leave");
    },
  },
};
</script>
<style lang="scss" scoped>
.member-classes-period {
  margin-bottom: 22px;
  padding-left: 14px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  width: calc(100% - 14px);
  /deep/ {
    .el-progress {
      margin-right: 8px;
    }
  }
}
.member-classes-period-title {
  display: flex;
  align-items: center;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: -14px;
    top: 7px;
    width: 6px;
    height: 6px;
    background: #cccccc;
    border-radius: 50%;
  }
}
.member-classes-period-title_hover {
  cursor: pointer;
  &:hover {
    color: $primary-color;
  }
}
.member-classes-period-info {
  margin-top: 8px;
}
.member-classes-period-icon {
  width: 16px;
  margin-right: 4px;
}
.member-classes-period-state {
  margin-right: 12px;
}
.member-classes-period-main {
  flex: 1;
}
.member-classes-period-progress {
  width: 36px;
  text-align: right;
}
.member-classes-period-btns {
  margin-right: 32px;
  display: flex;
  align-items: center;
  .color-9 {
    margin-right: 16px;
  }
}
.member-classes-period-btn {
  border: 1px solid #bfbfbf;
  border-radius: 19px;
  padding: 8px 16px;
  cursor: pointer;
  margin-right: 12px;
  &:last-child {
    margin-right: 0;
  }
}
.member-classes-period-btn_disable {
  background: #f5f5f5;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
